import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';
import { LinkCreatedTitleProps } from '../../types';
import styles from '../../styles.module.scss';
import classnames from 'classnames';

export function ContactLinkCreatedTitle({ username }: LinkCreatedTitleProps) {
  const { t } = useTranslation();

  return (
    <div>
      <span className={classnames(styles.title)}>{username}</span>{' '}
      <span className={classnames(styles.text)}>
        linked a {t(TranslationKeys.contact_one)}.
      </span>
    </div>
  );
}
